export function getNextProjectBridgeScheduleSelection(current = {}, scheduleId, checked) {
    if (!scheduleId) return current

    if (checked) {
        return selectProjectBridgeScheduleIds(current, [scheduleId])
    }

    return deselectProjectBridgeScheduleIds(current, [scheduleId])
}

export function selectProjectBridgeScheduleIds(current = {}, scheduleIds = []) {
    const next = { ...current }

    for (const scheduleId of scheduleIds) {
        if (!scheduleId) continue
        next[scheduleId] = true
    }

    return next
}

export function deselectProjectBridgeScheduleIds(current = {}, scheduleIds = []) {
    const next = { ...current }

    for (const scheduleId of scheduleIds) {
        delete next[scheduleId]
    }

    return next
}
